/* 32 North — Theme JS
   Mobile menu · cart count · cart drawer
   ============================================================
   v2 notes:
   - The live version had a "Cart Drawer" comment block that defined
     fetchCart/addToCart/updateCartCount and never opened a drawer, so
     "Add to Cart" ended at "Added" and went nowhere. There is now a real
     drawer, and the header cart link is a working fallback.
   - updateCartCount ran on every page load as an extra /cart.js request.
     The count now renders server-side in header.liquid and is only
     refetched after the cart actually changes.
   ============================================================ */

(function () {
  'use strict';

  /* ── Mobile menu ─────────────────────────────────────────── */
  var menuToggle = document.querySelector('.menu-toggle');
  var headerNav  = document.querySelector('.header-nav');

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = headerNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* ── Cart count ──────────────────────────────────────────── */
  function paintCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) { el.removeAttribute('hidden'); }
      else { el.setAttribute('hidden', ''); }
    });
    var title = document.querySelector('.cart-drawer-title');
    if (title) title.textContent = 'Your Cart (' + cart.item_count + ')';
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && (e.detail.cart || e.detail);
    if (cart && typeof cart.item_count !== 'undefined') paintCount(cart);
  });

  /* ── Cart drawer ─────────────────────────────────────────── */
  var drawer  = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.removeAttribute('hidden'); requestAnimationFrame(function () { overlay.classList.add('open'); }); }
    document.body.classList.add('cart-open');
    drawer.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('open');
      setTimeout(function () { overlay.setAttribute('hidden', ''); }, 300);
    }
    document.body.classList.remove('cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('cart:open', openDrawer);

  if (drawer) {
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  /* ── Simple ATC forms (single-variant cards) ─────────────── */
  document.querySelectorAll('[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          paintCount(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          if (btn) { btn.textContent = 'Added'; }
          openDrawer();
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
        })
        .catch(function () {
          if (btn) { btn.textContent = 'Error — try again'; btn.disabled = false; }
          /* Fall back to a normal POST so the customer is never stuck */
          setTimeout(function () { form.submit(); }, 600);
        });
    });
  });

})();
